import React from 'react';

import LockIcon from '../../../assets/icons/lock.svg';
import LockSubIcon from '../../../assets/icons/sub-lock.svg';
import UnlockIcon from '../../../assets/icons/open-lock.svg';
import UnlockSubIcon from '../../../assets/icons/open-sub-lock.svg';
import { TbBasket, TbBasketCheck } from 'react-icons/tb';

const imgDimensions = { width: 22, height: 22 };

const icons = {
  locked: <img src={LockIcon} alt="locked" {...imgDimensions} />,
  lockedSub: <img src={LockSubIcon} alt="locked" {...imgDimensions} />,
  unlocked: <img src={UnlockIcon} alt="unlocked" {...imgDimensions} />,
  unlockedSub: <img src={UnlockSubIcon} alt="unlocked" {...imgDimensions} />,
  basket: <TbBasket style={{ color: '#56e39f' }} size={24} />,
  basketCheck: <TbBasketCheck style={{ color: '#56e39f' }} size={24} />,
};

export default icons;
